import { useAppSelector } from 'src/app/store/hooks';
import { useAssignmentsLocationsListQuery } from 'src/common/external/bambi-api/bambiApi';
import { selectCurrentAssignmentLocationId } from 'src/features/live-map/liveMap.slice';

export function useAssignmentLiveMapListViewModel() {
  const assignmentLocationsSearchTerm = useAppSelector(
    (state) => state.liveMap.assignmentLocationsSearchTerm
  );
  const { data, isLoading, isFetching } = useAssignmentsLocationsListQuery({
    search: assignmentLocationsSearchTerm,
  });
  const selectedAssignmentLocationId = useAppSelector(
    selectCurrentAssignmentLocationId
  );

  return {
    assignmentLocations: data?.results,
    isLoading,
    isFetching,
    selectedAssignmentLocationId,
  };
}
